import React from 'react';
import { css } from 'styled-components/macro';
import { getTotal } from 'app/components/Charts/sunburst/common/tooltip/utils';
import { tooltiprowcss } from 'app/components/Charts/sunburst/common/tooltip/styles';
import { formatLocale } from 'app/utils/formatLocale';
import { useRecoilValue } from 'recoil';
import { transactionTypeAtom } from 'app/state/recoil/atoms';

interface TreemapTooltipProps {
  node: any;
  showAll?: boolean;
}

const tooltipcss = css`
  z-index: 2;
  width: 340px;
  display: flex;
  font-size: 12px;
  background: #fff;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
`;

const titlecellcss = css`
  width: calc(100% - 50px);
`;

export function TreemapTooltip(props: TreemapTooltipProps) {
  const transactionType = useRecoilValue(transactionTypeAtom);
  const renderedChilds =
    props.node.data.orgs && props.node.data.orgs.length > 5 && !props.showAll
      ? props.node.data.orgs.slice(0, 5)
      : props.node.data.orgs;
  const moreChildsCount =
    props.node.data.orgs && props.node.data.orgs.length > 5 && !props.showAll
      ? props.node.data.orgs.length - 5
      : 0;

  return (
    <div css={tooltipcss}>
      <div css={tooltiprowcss(true, '#d1d1d1')}>
        <div>Organisation type</div>
        <div>{transactionType.name}</div>
      </div>
      <div css={tooltiprowcss(true, '#2e4063')}>
        <div css={titlecellcss}>{props.node.data.name}</div>
        <div>{formatLocale(props.node.data.value)}</div>
      </div>
      {renderedChilds &&
        renderedChilds.map((child: any) => (
          <div key={child.title} css={tooltiprowcss(false, '#626262')}>
            <div css={titlecellcss}>{child.title}</div>
            <div>{getTotal(child, true)}</div>
          </div>
        ))}
      {moreChildsCount > 0 && (
        <div css={tooltiprowcss(true, '#d1d1d1')}>
          {moreChildsCount} more organisations
        </div>
      )}
    </div>
  );
}
